import Vue from 'vue';

import { 計画書データListItemResponse } from '@/openapi/user';

import StorageDao from '@/classes/common/StorageDao';
import 決算期Utility from '@/classes/common/決算期Utility';
import AbstractデータService from '@/classes/service/AbstractデータService';

type State = {
  計画書: 計画書データListItemResponse | null;
};

const state = Vue.observable<State>({
  計画書: null,
});

export default Vue.extend({
  name: 'M計画書Mixin',

  computed: {
    計画書(): 計画書データListItemResponse {
      if (state.計画書 === null) {
        const storaged = StorageDao.get計画書();
        state.計画書 = storaged;
      }
      return state.計画書;
    },
    moneyUnit(): number | null {
      return AbstractデータService.getMoneyUnit(this.計画書.c千円表示フラグ);
    },
    モニタリング会計期間(): number {
      return this.計画書.cモニタリング会計期間 ?? this.計画書.c計画0期の決算期;
    },
    モニタリング会計期間Year(): number {
      return 決算期Utility.getYear(this.モニタリング会計期間);
    },
  },

  methods: {
    set計画書(計画書: 計画書データListItemResponse): void {
      AbstractデータService.set計画書 = 計画書;
      StorageDao.save計画書(計画書);
      StorageDao.save計画書Local({
        c第1期月次作成フラグ: 計画書.c第1期月次作成フラグ,
      });
      state.計画書 = 計画書;
    },
    post計画書ToParentTab(v計画書: 計画書データListItemResponse): void {
      this.set計画書(v計画書);
      // 親タブへ受け渡し
      if (window.opener === null) return;
      window.opener.postMessage({ v計画書 }, location.origin);
    },
  },
});
